var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-modal',{attrs:{"open":_vm.open,"dismiss":_vm.dismiss,"showCloseButton":false}},[_c('h3',[_vm._v("感謝您補充資訊！")]),_c('app-button',{attrs:{"data-label":"update-factory-success-apply"},on:{"click":_vm.dismiss}},[_vm._v("確認")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }